import * as React from "react";
import {
  WheelPicker,
  WheelPickerOption,
  WheelPickerWrapper,
} from "@ncdai/react-wheel-picker";

const createArray = (length: number, add = 0): WheelPickerOption<number>[] =>
  Array.from({ length }, (_, i) => {
    const value = i + add;
    return {
      label: value.toString().padStart(2, "0"),
      value: value,
    };
  });

const hourOptions = createArray(12, 1);
const minuteOptions = createArray(60);
const meridiemOptions: WheelPickerOption[] = [
  { label: "AM", value: "AM" },
  { label: "PM", value: "PM" },
];

interface TimeSelectWheelProps {
  onChange?: (time: string) => void;
  initialValue?: string;
}

export function TimeSelectWheel({
  onChange,
  initialValue,
}: TimeSelectWheelProps) {
  // Parse initial value if provided (format: "HH:MM AM/PM")
  const parseInitialTime = (timeString?: string) => {
    if (!timeString)
      return { hour: 9, minute: 0, meridiem: "AM" as "AM" | "PM" };

    try {
      const [time, meridiem] = timeString.split(" ");
      const [hourStr, minuteStr] = time.split(":");
      const hour = parseInt(hourStr, 10);
      const minute = parseInt(minuteStr, 10);

      return {
        hour: hour,
        minute: minute,
        meridiem: meridiem as "AM" | "PM",
      };
    } catch {
      return { hour: 9, minute: 0, meridiem: "AM" as "AM" | "PM" };
    }
  };

  const initialTime = parseInitialTime(initialValue);
  const [hour, setHour] = React.useState(initialTime.hour);
  const [minute, setMinute] = React.useState(initialTime.minute);
  const [meridiem, setMeridiem] = React.useState<"AM" | "PM">(
    initialTime.meridiem
  );

  React.useEffect(() => {
    if (onChange) {
      const formattedTime = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")} ${meridiem}`;
      onChange(formattedTime);
    }
  }, [hour, minute, meridiem, onChange]);

  return (
    <div className="w-56">
      <WheelPickerWrapper>
        <WheelPicker
          options={hourOptions}
          defaultValue={hour}
          onValueChange={(value: number) => setHour(value)}
          infinite
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
        <WheelPicker
          options={minuteOptions}
          defaultValue={minute}
          onValueChange={(value: number) => setMinute(value)}
          infinite
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
        <WheelPicker
          options={meridiemOptions}
          defaultValue={meridiem}
          onValueChange={(value: string) => setMeridiem(value as "AM" | "PM")}
          // visibleCount={10}
          classNames={{
            highlightWrapper: "bg-[#1a1a1a] h-fit",
          }}
        />
      </WheelPickerWrapper>
    </div>
  );
}
